import { render, staticRenderFns } from "./WeaponsEditDialog.vue?vue&type=template&id=7c335d26&"
import script from "./WeaponsEditDialog.vue?vue&type=script&lang=ts&"
export * from "./WeaponsEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WeaponsEditDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports